import {
  CLEAR_ROUTES_REDUCER,
  CREATE_NEW_ROUTE,
  CREATE_NEW_ROUTE_STATION,
  CREATE_NEW_ROUTE_SUCCESS,
  DELETE_ROUTE,
  DELETE_ROUTE_STATION,
  DELETE_ROUTE_SUCCESS,
  EDIT_ROUTE,
  COPY_ROUTE,
  EDIT_ROUTE_SUCCESS,
  COPY_ROUTE_SUCCESS,
  GET_ACTIVE_ROUTE_DETAILS,
  GET_ACTIVE_ROUTE_DETAILS_SUCCESS,
  GET_ACTIVE_ROUTE_DETAILS_FAILED,
  GET_INACTIVE_ROUTE_DETAILS,
  GET_INACTIVE_ROUTE_DETAILS_SUCCESS,
  GET_INACTIVE_ROUTE_DETAILS_FAILED,
  GET_ACTIVE_ROUTES_HISTORY,
  GET_ACTIVE_ROUTES_HISTORY_SUCCESS,
  GET_BUS_ROUTES,
  GET_BUS_ROUTES_SUCCESS,
  GET_DETAILED_ACTIVE_ROUTE_HISTORY,
  GET_DETAILED_ACTIVE_ROUTE_HISTORY_FAILURE,
  GET_DETAILED_ACTIVE_ROUTE_HISTORY_SUCCESS,
  GET_DRIVER_ROUTES,
  GET_DRIVER_ROUTES_SUCCESS,
  GET_ROUTE_BY_ID,
  GET_ROUTE_BY_ID_FAILURE,
  GET_ROUTE_BY_ID_SUCCESS,
  CLEAR_ROUTE_BY_ID,
  GET_ROUTE_CARRIERS_RELATIONS,
  GET_ROUTE_CARRIERS_RELATIONS_SUCCESS,
  GET_ROUTE_HISTORY_STATIONS_STATS,
  GET_ROUTE_HISTORY_STATIONS_STATS_FAILURE,
  GET_ROUTE_HISTORY_STATIONS_STATS_SUCCESS,
  GET_ROUTE_HISTORY_STUDENTS_STATS,
  GET_ROUTE_HISTORY_STUDENTS_STATS_FAILURE,
  GET_ROUTE_HISTORY_STUDENTS_STATS_SUCCESS,
  GET_TODAY_ROUTES,
  GET_TODAY_ROUTES_SUCCESS,
  HIDE_ROUTE_LOADER,
  HIDE_ROUTES_HISTORY_LOADER,
  HIDE_ROUTE_STATIONS_LOADER,
  REFLECT_STATIONS,
  REMOVE_STATIONS_BY_DIRECTION,
  SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY,
  SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_SUCCESS,
  SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY,
  SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_SUCCESS,
  SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY,
  SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_SUCCESS,
  SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY,
  SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_SUCCESS,
  SEARCH_ROUTES,
  SEARCH_ROUTES_SUCCESS,
  SELECT_ROUTE_IN_MANAGE_ROUTES_PAGE,
  SET_BUS_ROUTES_LOADING,
  SET_COMMON_ROUTE_SCHEDULE,
  SET_DRIVER_ROUTES_LOADING,
  SET_ROUTE_HISTORY_DELAYS_LOADER,
  SET_ROUTE_HISTORY_DETAILS_LOADER,
  SET_ROUTE_HISTORY_LOCATIONS_LOADER,
  SET_ROUTE_HISTORY_STATIONS_LOADER,
  SET_ROUTE_HISTORY_STUDENTS_LOADER,
  SET_ROUTES_LOADING,
  SHOW_ROUTES_HISTORY_LOADER,
  SHOW_ROUTE_STATIONS_LOADER,
  UPDATE_EXISTING_SEARCH_ROUTES,
  UPDATE_RECENTLY_ADDED_ROUTE,
  UPDATE_ROUTE_RELATIONS,
  UPDATE_STATION,
  UPDATE_STATIONS_SCHEDULE,
  UPDATE_STATION_ORDER,
  GET_ACTIVE_ROUTE_DETAILS_INFO,
  GET_ACTIVE_ROUTE_DETAILS_INFO_SUCCESS,
  UPDATE_STATION_SUCCESS,
  UPDATE_STATION_FAILURE,
  TOGGLE_STATION_MODAL,
  TOGGLE_ROUTE_MODAL,
  TOGGLE_COPY_ROUTE_MODAL,
  ROUTE_MODAL_SUBMITED_SUCCESS,
  ROUTE_MODAL_SUBMITED_FAILURE,
  GET_CAMPUSES_FOR_ROUTES,
  GET_CAMPUSES_FOR_ROUTES_SUCCESS,
  GET_CAMPUSES_FOR_ROUTES_FAILURE,
  CLEAR_CAMPUSES_FOR_ROUTES,
  GET_LOG_ROUTE_DATA,
  GET_LOG_ROUTE_DATA_SUCCESS,
  GET_LOG_ROUTE_DATA_FAILURE,
  GET_MAP_ROUTE_DATA_SUCCESS,
  UPDATE_SELECTED_ROUTES,
  GET_ROUTE_STOP_DATA,
  GET_ROUTE_STOP_DATA_SUCCESS,
  GET_ROUTE_STOP_DATA_FAILURE,
  TERMINATE_ACTIVE_ROUTE_TOGGLE_CONFIRMATION_MODAL,
  TERMINATE_ACTIVE_ROUTE_CONFIRM,
  TERMINATE_ACTIVE_ROUTE_SUCCESS,
  TERMINATE_ACTIVE_ROUTE_FAILED,
  GET_TODAY_ROUTES_THROTTLE,
  ACTIVE_ROUTE_LOCATION_HISTORY,
  ACTIVE_ROUTE_LOCATION_HISTORY_FAILURE,
  ACTIVE_ROUTE_LOCATION_HISTORY_SUCCESS,
  FETCH_ALL_ROUTES_PAGINATED,
  FETCH_ALL_ROUTES_PAGINATED_SUCCESS,
} from '../constants/ActionTypes';

export const addNewRoute = ({ route }) => ({
  type: CREATE_NEW_ROUTE,
  payload: { route },
});

export const addNewRouteSuccess = route => ({
  type: CREATE_NEW_ROUTE_SUCCESS,
  payload: { route },
});

export const createNewRouteStation = (station, routeId, direction, completionHook) => ({
  type: CREATE_NEW_ROUTE_STATION,
  payload: {
    station,
    routeId,
    direction,
    completionHook,
  },
});

export const deleteRoute = (routeId, urlToRedirect = '') => ({
  type: DELETE_ROUTE,
  payload: { routeId, urlToRedirect },
});

export const deleteRouteSuccess = routeId => ({
  type: DELETE_ROUTE_SUCCESS,
  payload: { routeId },
});

export const deleteStation = (routeId, stationId, direction, completionHook) => ({
  type: DELETE_ROUTE_STATION,
  payload: { routeId, stationId, direction, completionHook },
});

export const editRoute = ({ id, number, name, campusId, days }) => ({
  type: EDIT_ROUTE,
  payload: { id, number, name, campusId, days },
});

export const editRouteSuccess = route => ({
  type: EDIT_ROUTE_SUCCESS,
  payload: { route },
});

export const copyRoute = ({ id, number, name, campusId }) => ({
  type: COPY_ROUTE,
  payload: { id, number, name, campusId },
});

export const copyRouteSuccess = route => ({
  type: COPY_ROUTE_SUCCESS,
  payload: { route },
});

export const getActiveRouteDetails = routeId => ({
  type: GET_ACTIVE_ROUTE_DETAILS,
  payload: { routeId },
});

export const getActiveRouteDetailsSuccess = activeRouteDetails => ({
  type: GET_ACTIVE_ROUTE_DETAILS_SUCCESS,
  payload: { activeRouteDetails },
});

export const getActiveRouteDetailsFailed = () => ({
  type: GET_ACTIVE_ROUTE_DETAILS_FAILED,
});

export const getInactiveRouteDetails = routeId => ({
  type: GET_INACTIVE_ROUTE_DETAILS,
  payload: { routeId },
});

export const getInactiveRouteDetailsSuccess = inactiveRouteDetails => ({
  type: GET_INACTIVE_ROUTE_DETAILS_SUCCESS,
  payload: { inactiveRouteDetails },
});

export const getInactiveRouteDetailsFailed = () => ({
  type: GET_INACTIVE_ROUTE_DETAILS_FAILED,
});

export const getActiveRouteDetailsInfo = routeId => ({
  type: GET_ACTIVE_ROUTE_DETAILS_INFO,
  payload: { routeId },
});

export const getActiveRouteDetailsInfoSuccess = activeRouteDetails => ({
  type: GET_ACTIVE_ROUTE_DETAILS_INFO_SUCCESS,
  payload: { activeRouteDetails },
});

export const terminateActiveRouteModalToggle = () => ({
  type: TERMINATE_ACTIVE_ROUTE_TOGGLE_CONFIRMATION_MODAL,
});

export const confirmTerminateActiveRoute = (routeId, completed = false) => ({
  type: TERMINATE_ACTIVE_ROUTE_CONFIRM,
  payload: { routeId, completed },
});

export const terminateActiveRouteSuccess = activeRouteDetails => ({
  type: TERMINATE_ACTIVE_ROUTE_SUCCESS,
  payload: { activeRouteDetails },
});

export const terminateActiveRouteFailed = () => ({
  type: TERMINATE_ACTIVE_ROUTE_FAILED,
});

export const getActiveRoutesHistory = (query = {}, params = {}, affectQuery = false) => ({
  type: GET_ACTIVE_ROUTES_HISTORY,
  payload: { query, params, affectQuery },
});

export const getActiveRoutesHistorySuccess = (items = [], pageCount = 1) => ({
  type: GET_ACTIVE_ROUTES_HISTORY_SUCCESS,
  payload: { items, pageCount },
});

export const getAllRoutes = (query, loadAllRoutesAtOnce = false, routeSearchTerm) => ({
  type: SEARCH_ROUTES,
  payload: { query, loadAllRoutesAtOnce, routeSearchTerm },
});

export const getAllRoutesSuccess = (routes, pageCount, routeSearchTerm) => ({
  type: SEARCH_ROUTES_SUCCESS,
  payload: { routes, pageCount, routeSearchTerm },
});

export const fetchAllRoutesPaginated = () => ({
  type: FETCH_ALL_ROUTES_PAGINATED,
});

export const fetchAllRoutesPaginatedSuccess = routes => ({
  type: FETCH_ALL_ROUTES_PAGINATED_SUCCESS,
  payload: { routes },
});

export const getDetailedActiveRouteHistory = (routeId = '') => ({
  type: GET_DETAILED_ACTIVE_ROUTE_HISTORY,
  payload: { routeId },
});

export const getDetailedActiveRouteHistoryFailure = () => ({
  type: GET_DETAILED_ACTIVE_ROUTE_HISTORY_FAILURE,
});

export const getDetailedActiveRouteHistorySuccess = (details = {}) => ({
  type: GET_DETAILED_ACTIVE_ROUTE_HISTORY_SUCCESS,
  payload: { details },
});

export const getRouteById = id => ({
  type: GET_ROUTE_BY_ID,
  payload: { id },
});

export const getRouteByIdFailure = error => ({
  type: GET_ROUTE_BY_ID_FAILURE,
  payload: { error },
});

export const getRouteByIdSuccess = route => ({
  type: GET_ROUTE_BY_ID_SUCCESS,
  payload: { route },
});

export const clearRouteById = () => ({
  type: CLEAR_ROUTE_BY_ID,
});

export const getRouteCarriersRelations = routeId => ({
  type: GET_ROUTE_CARRIERS_RELATIONS,
  payload: { routeId },
});

export const getRouteCarriersRelationsSuccess = carriersRelations => ({
  type: GET_ROUTE_CARRIERS_RELATIONS_SUCCESS,
  payload: { carriersRelations },
});

export const getRouteHistoryStationsStats = (routeId = '') => ({
  type: GET_ROUTE_HISTORY_STATIONS_STATS,
  payload: { routeId },
});

export const getRouteHistoryStationsStatsFailure = () => ({
  type: GET_ROUTE_HISTORY_STATIONS_STATS_FAILURE,
});

export const getRouteHistoryStationsStatsSuccess = (statistics = {}) => ({
  type: GET_ROUTE_HISTORY_STATIONS_STATS_SUCCESS,
  payload: { statistics },
});

export const getRouteHistoryStudentsStats = (routeId = '') => ({
  type: GET_ROUTE_HISTORY_STUDENTS_STATS,
  payload: { routeId },
});

export const getRouteHistoryStudentsStatsFailure = () => ({
  type: GET_ROUTE_HISTORY_STUDENTS_STATS_FAILURE,
});

export const getRouteHistoryStudentsStatsSuccess = (statistics = {}) => ({
  type: GET_ROUTE_HISTORY_STUDENTS_STATS_SUCCESS,
  payload: { statistics },
});

export const getTodayRoutes = () => ({
  type: GET_TODAY_ROUTES,
});

export const getTodayRoutesThrottle = () => ({
  type: GET_TODAY_ROUTES_THROTTLE,
});

export const getTodayRoutesSuccess = activeRoutes => ({
  type: GET_TODAY_ROUTES_SUCCESS,
  payload: { activeRoutes },
});

export const hideRouteLoader = () => ({
  type: HIDE_ROUTE_LOADER,
});

export const showRoutesHistoryLoader = () => ({
  type: SHOW_ROUTES_HISTORY_LOADER,
});

export const hideRoutesHistoryLoader = () => ({
  type: HIDE_ROUTES_HISTORY_LOADER,
});

export const hideRouteStationsLoader = () => ({
  type: HIDE_ROUTE_STATIONS_LOADER,
});

export const reflectStationsFromDirection = (routeId, direction) => ({
  type: REFLECT_STATIONS,
  payload: { routeId, direction },
});

export const removeStationsByDirection = (routeId, direction, urlToRedirect = '') => ({
  type: REMOVE_STATIONS_BY_DIRECTION,
  payload: { routeId, direction, urlToRedirect },
});

export const searchActiveRouteDelaysHistory = (routeId = '', query = {}, affectQuery = false) => ({
  type: SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY,
  payload: { routeId, query, affectQuery },
});

export const searchActiveRouteDelaysHistoryFailure = () => ({
  type: SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_FAILURE,
});

export const searchActiveRouteDelaysHistorySuccess = (delays = [], pageCount = 1) => ({
  type: SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_SUCCESS,
  payload: { delays, pageCount },
});

export const searchActiveRouteLocationsHistory = (
  routeId = '',
  query = {},
  affectQuery = false,
) => ({
  type: SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY,
  payload: { routeId, query, affectQuery },
});

export const searchActiveRouteLocationsHistoryFailure = () => ({
  type: SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_FAILURE,
});

export const searchActiveRouteLocationsHistorySuccess = (locations = [], pageCount = 1) => ({
  type: SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_SUCCESS,
  payload: { locations, pageCount },
});

export const activeRouteLocationHistory = (routeId = '') => ({
  type: ACTIVE_ROUTE_LOCATION_HISTORY,
  payload: { routeId },
});

export const activeRouteLocationHistoryFailure = () => ({
  type: ACTIVE_ROUTE_LOCATION_HISTORY_FAILURE,
});

export const activeRouteLocationHistorySuccess = (locations = []) => ({
  type: ACTIVE_ROUTE_LOCATION_HISTORY_SUCCESS,
  payload: { locations },
});

export const searchActiveRouteStationsHistory = (
  routeId = '',
  query = {},
  fetchStats = false,
  affectQuery = false,
) => ({
  type: SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY,
  payload: { routeId, query, fetchStats, affectQuery },
});

export const searchActiveRouteStationsHistoryFailure = () => ({
  type: SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_FAILURE,
});

export const searchActiveRouteStationsHistorySuccess = (stations = [], pageCount = 1) => ({
  type: SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_SUCCESS,
  payload: { stations, pageCount },
});

export const searchActiveRouteStudentsHistory = (
  routeId = '',
  query = {},
  fetchStats = false,
  affectQuery = false,
) => ({
  type: SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY,
  payload: { routeId, query, fetchStats, affectQuery },
});

export const searchActiveRouteStudentsHistoryFailure = () => ({
  type: SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_FAILURE,
});

export const searchActiveRouteStudentsHistorySuccess = (students = [], pageCount = 1) => ({
  type: SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_SUCCESS,
  payload: { students, pageCount },
});

export const selectRoute = selectedRoute => ({
  type: SELECT_ROUTE_IN_MANAGE_ROUTES_PAGE,
  payload: { selectedRoute },
});

export const setCommonRouteSchedule = (routeId, direction) => ({
  type: SET_COMMON_ROUTE_SCHEDULE,
  payload: { routeId, direction },
});

export const setRouteHistoryDelaysLoader = (flag = false) => ({
  type: SET_ROUTE_HISTORY_DELAYS_LOADER,
  payload: { flag },
});

export const setRouteHistoryDetailsLoader = (flag = false) => ({
  type: SET_ROUTE_HISTORY_DETAILS_LOADER,
  payload: { flag },
});

export const setRouteHistoryLocationsLoader = (flag = false) => ({
  type: SET_ROUTE_HISTORY_LOCATIONS_LOADER,
  payload: { flag },
});

export const setRouteHistoryStationsLoader = (flag = false) => ({
  type: SET_ROUTE_HISTORY_STATIONS_LOADER,
  payload: { flag },
});

export const setRouteHistoryStudentsLoader = (flag = false) => ({
  type: SET_ROUTE_HISTORY_STUDENTS_LOADER,
  payload: { flag },
});

export const setRoutesLoading = (isLoading = false) => ({
  type: SET_ROUTES_LOADING,
  payload: { isLoading },
});

export const showRouteStationsLoader = () => ({
  type: SHOW_ROUTE_STATIONS_LOADER,
});

export const updateExistingSearchRoutes = routes => ({
  type: UPDATE_EXISTING_SEARCH_ROUTES,
  payload: routes,
});

export const updateRecentlyAddedRoute = route => ({
  type: UPDATE_RECENTLY_ADDED_ROUTE,
  payload: route,
});

export const updateStation = (routeId, stationId, direction, station, completionHook) => ({
  type: UPDATE_STATION,
  payload: {
    routeId,
    stationId,
    direction,
    station,
    completionHook,
  },
});

export const updateStationsSchedule = (routeId, direction, schedule, completionHook) => ({
  type: UPDATE_STATIONS_SCHEDULE,
  payload: {
    routeId,
    direction,
    schedule,
    completionHook,
  },
});

export const updateStationOrder = (routeId, stationId, direction, operation) => ({
  type: UPDATE_STATION_ORDER,
  payload: {
    routeId,
    stationId,
    direction,
    operation,
  },
});

export const updateRouteRelations = (routeId, busesAndDrivers) => ({
  type: UPDATE_ROUTE_RELATIONS,
  payload: { routeId, busesAndDrivers },
});

export const getBusRoutes = busId => ({
  type: GET_BUS_ROUTES,
  payload: { busId },
});

export const getBusRoutesSuccess = (busId, busRoutes) => ({
  type: GET_BUS_ROUTES_SUCCESS,
  payload: { busId, busRoutes },
});

export const getDriverRoutes = driverId => ({
  type: GET_DRIVER_ROUTES,
  payload: { driverId },
});

export const getDriverRoutesSuccess = (driverId, driverRoutes) => ({
  type: GET_DRIVER_ROUTES_SUCCESS,
  payload: { driverId, driverRoutes },
});

export const setBusRoutesLoading = isLoading => ({
  type: SET_BUS_ROUTES_LOADING,
  payload: { isLoading },
});

export const setDriverRoutesLoading = isLoading => ({
  type: SET_DRIVER_ROUTES_LOADING,
  payload: { isLoading },
});

export const clearRoutesReducer = () => ({
  type: CLEAR_ROUTES_REDUCER,
});

export const updateStationSuccess = () => ({
  type: UPDATE_STATION_SUCCESS,
});

export const updateStationFailure = () => ({
  type: UPDATE_STATION_FAILURE,
});

export const toggleStationModal = () => ({
  type: TOGGLE_STATION_MODAL,
});

export const toggleRouteModal = () => ({
  type: TOGGLE_ROUTE_MODAL,
});

export const toggleCopyRouteModal = route => ({
  type: TOGGLE_COPY_ROUTE_MODAL,
  payload: { route },
});

export const routeModalSubmitedSuccess = () => ({
  type: ROUTE_MODAL_SUBMITED_SUCCESS,
});

export const routeModalSubmitedFailure = () => ({
  type: ROUTE_MODAL_SUBMITED_FAILURE,
});

export const getCampusesForRoutes = () => ({
  type: GET_CAMPUSES_FOR_ROUTES,
});

export const getCampusesForRoutesSuccess = campuses => ({
  type: GET_CAMPUSES_FOR_ROUTES_SUCCESS,
  payload: { campuses },
});

export const getCampusesForRoutesFailure = () => ({
  type: GET_CAMPUSES_FOR_ROUTES_FAILURE,
});

export const clearCampusesForRoutes = () => ({
  type: CLEAR_CAMPUSES_FOR_ROUTES,
});

export const getLogRouteData = (routeId, query) => ({
  type: GET_LOG_ROUTE_DATA,
  payload: {
    routeId,
    query,
  },
});

export const getLogRouteDataSuccess = ({ data, pageCount }) => ({
  type: GET_LOG_ROUTE_DATA_SUCCESS,
  payload: { data, pageCount },
});

export const getLogRouteDataFailure = () => ({
  type: GET_LOG_ROUTE_DATA_FAILURE,
});

export const getMapRouteDataSuccess = data => ({
  type: GET_MAP_ROUTE_DATA_SUCCESS,
  payload: data,
});

export const updateSelectedRoutes = data => ({
  type: UPDATE_SELECTED_ROUTES,
  payload: data,
});

export const getRouteStopData = (routeId, query) => ({
  type: GET_ROUTE_STOP_DATA,
  payload: {
    routeId,
    query,
  },
});

export const getRouteStopDataSuccess = ({ data, pageCount }) => ({
  type: GET_ROUTE_STOP_DATA_SUCCESS,
  payload: { data, pageCount },
});

export const getRouteStopDataFailure = () => ({
  type: GET_ROUTE_STOP_DATA_FAILURE,
});
